import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IvvaStore } from '../store/store.model';
import { map, Observable, take } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate {
	private readonly router = inject(Router);
	private readonly store = inject(Store<IvvaStore>);

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
		return this.store.select('offers', 'user').pipe(
			take(1),
			map((user) => {
				if (user) {
					const authRoles: string[] = route.data['authRoles'];

					if (authRoles?.length) {
						const id = route.paramMap.get('id');

						const access = authRoles.some((role) => {
							if (role === 'eligibleForDiscount') {
								return user.eligibleForDiscount;
							} else if (role === 'socialOrg') {
								return user.socialOrg;
							}

							return false;
						});

						if (!access) {
							this.router.navigate(['/', 'offers', id, 'denied']);
							return false;
						}
					}

					return true;
				}

				const link = route.url.reduce((link, segment) => `${link}/${segment.path}`, '');
				this.saveRedirect(link);

				document.location.href = '/acmidm';
				return false;
			})
		);
	}

	private saveRedirect(link: string) {
		const data = JSON.stringify({ time: Date.now(), link });
		localStorage.setItem('redirect', data);
	}
}
